import { Grid, MenuItem, TextField } from "@mui/material";
import classNames from "classnames";

import { countryList } from "../../internationalPhoneCodes";
import countryCodesToTimezones from "../../timezones";
import { Timezone } from "../../types";

interface ComponentPropsType {
  canEditUserProfileInfo?: boolean;
  classes: Record<string, string>;
  country: string;
  countryRef: React.RefObject<HTMLInputElement>;
  handleFieldValueChange: (field: string, value: any) => void;
  language: string;
  languageList: Array<{ code: string; name: string }>;
  languageRef: React.RefObject<HTMLInputElement>;
  setShouldBlockNavigation: (shouldBlock: boolean) => void;
  timezone: string;
  timezoneList: Timezone[];
  timezoneRef: React.RefObject<HTMLInputElement>;
}

const AddressInfoComponent = (props: ComponentPropsType) => {
  const {
    canEditUserProfileInfo = true,
    classes,
    country,
    countryRef,
    handleFieldValueChange,
    language,
    languageList,
    languageRef,
    setShouldBlockNavigation,
    timezone,
    timezoneList,
    timezoneRef,
  } = props;

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="country"
            label="Country"
            name="country"
            margin="normal"
            variant="outlined"
            required
            select
            SelectProps={{
              classes: {
                select: classes.selectRoot,
              },
            }}
            value={country}
            onChange={(event) => {
              setShouldBlockNavigation(true);
              handleFieldValueChange("country", event.target.value);
              handleFieldValueChange("timezone", "");
              handleFieldValueChange(
                "timezoneList",
                countryCodesToTimezones[
                  event.target.value as keyof typeof countryCodesToTimezones
                ]
              );
            }}
            className={classes.fullWidth}
            InputLabelProps={{
              htmlFor: "country",
              shrink: true,
              classes: {
                root: classes.upperText,
              },
            }}
            InputProps={{
              id: "country",
              autoComplete: "country",
            }}
            inputRef={countryRef}
          >
            {countryList.map((country) => {
              return (
                <MenuItem key={country.iso2} value={country.iso2}>
                  {country.name}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            classes={{ root: classes.textFieldRoot }}
            disabled={!canEditUserProfileInfo}
            id="language"
            label="Language"
            name="language"
            margin="normal"
            variant="outlined"
            select
            SelectProps={{
              classes: {
                select: classes.selectRoot,
              },
            }}
            value={language}
            onChange={(event) => {
              setShouldBlockNavigation(true);
              handleFieldValueChange("language", event.target.value);
            }}
            inputRef={languageRef}
            InputLabelProps={{
              htmlFor: "language",
              shrink: true,
              classes: {
                root: classes.upperText,
              },
            }}
            InputProps={{
              id: "language",
              autoComplete: "language",
            }}
            className={classNames(classes.fullWidth, {
              [classes.disabledInputField]: !canEditUserProfileInfo,
            })}
            required
          >
            {languageList.map((language) => {
              return (
                <MenuItem key={language.code} value={language.code}>
                  {language.name}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <TextField
          id="timezone"
          label="Time Zone"
          name="timezone"
          margin="normal"
          variant="outlined"
          fullWidth
          required
          disabled={!country}
          select
          SelectProps={{
            classes: {
              select: classes.selectRoot,
            },
          }}
          value={timezone}
          onChange={(event) => {
            setShouldBlockNavigation(true);
            handleFieldValueChange("timezone", event.target.value);
          }}
          inputRef={timezoneRef}
          InputLabelProps={{
            shrink: true,
            classes: {
              root: classes.upperText,
            },
          }}
          InputProps={{
            id: "timezone",
            autoComplete: "off",
          }}
        >
          {timezoneList.map((timezone) => (
            <MenuItem key={timezone.tz} value={timezone.tz}>
              {timezone.tz}
              {timezone.comments && ` [${timezone.comments}]`}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
};

export default AddressInfoComponent;
